module.exports = __webpack_public_path__ + "sk-trip-wizard-card-bottom-left.2FBDWmtQ.png";